import type { HbBidderConfig } from '../types'

export const TAPPX: HbBidderConfig = {
    bidder: 'tappx',
    params: ({ platform, type }) => {
        const tappxkey = platform === 'desktop' ? 'pub-93521-desktop-7229' : 'pub-93520-mweb-7179'
        if (type === 'rewarded') {
            return {
                tappxkey,
                endpoint: 'vz43701pg',
                host: 'vz43701pg.pub.tappx.com/rtb/',
            }
        }
        return {
            tappxkey,
            endpoint: 'zz43701pg',
            host: 'zz43701pg.pub.tappx.com/rtb/',
        }
    },
}
